export default {
  PENDING: Symbol('PENDING'),
  NONE_RETURNED: Symbol('NONE_FOUND'),
  INVALID_LOCATION_REQUEST: Symbol('INVALID_LOCATION_REQUEST'),
  POINTS_RETURNED: Symbol('POINTS_RETURNED'),
};
